export default "__VITE_ASSET__DohyhTbD__"